import { defineStore } from "pinia";

type Role = "manager" | "editor" | "reader" | undefined;

interface State {
  role: Role;
  permissions: {
    isEnabled: boolean;

    canLockBlocks: boolean;
    canLockSections: boolean;

    canEditLockedSections: boolean;
    canEditLockedBlocks: boolean;
    canRemoveFiles: boolean;
  };
}

export type PermissionOverrides = Partial<
  Omit<State["permissions"], "isEnabled">
>;

export const useRolesStore = defineStore("roles", {
  state: (): State => ({
    role: undefined,
    permissions: {
      isEnabled: false,

      canLockBlocks: true,
      canLockSections: true,

      canEditLockedSections: true,
      canEditLockedBlocks: true,

      canRemoveFiles: true,
    },
  }),

  getters: {
    arePermissionsEnabled: (state) => state.permissions.isEnabled,
  },

  actions: {
    setRole(role: Role, overrides?: PermissionOverrides) {
      if (role === "manager" || role === "editor" || role === "reader") {
        this.permissions.isEnabled = true;

        if (role === "manager") {
          this.permissions.canLockBlocks = true;
          this.permissions.canLockSections = true;

          this.permissions.canEditLockedSections = true;
          this.permissions.canEditLockedBlocks = true;

          this.permissions.canRemoveFiles = true;
        }

        if (role === "editor") {
          this.permissions.canLockBlocks = false;
          this.permissions.canLockSections = false;

          this.permissions.canEditLockedSections = true;
          this.permissions.canEditLockedBlocks = true;

          this.permissions.canRemoveFiles = true;
        }

        if (role === "reader") {
          this.permissions.canLockBlocks = false;
          this.permissions.canLockSections = false;

          this.permissions.canEditLockedSections = false;
          this.permissions.canEditLockedBlocks = false;

          this.permissions.canRemoveFiles = true;
        }

        if (overrides) {
          for (const key of Object.keys(
            overrides
          ) as (keyof PermissionOverrides)[]) {
            const value = overrides[key];
            if (value !== undefined) {
              this.permissions[key] = value;
            }
          }
        }
      }
    },
  },
});
